<!--人文美育-视频库管理-->
<template>
    <div class="course-container" >
        <div class="base-create-container">
            <!--创建-->
            <div class="head-container">
                <div class="left-head-container">
                    <el-input style="width: 240px" v-model="keyword" placeholder="请输入关键字" class="input-with-select">
                        <template #append>
                            <el-button type="primary" @click="handleQuery" style="background-color: #3b62f8;color: #fff" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
                <div class="right-head-container">
                    <el-button type="primary" size="small" @click="backList">返回</el-button>
                </div>
            </div>
            <div class="info-container">
                <div class="book-item" v-for="item in videoList">
                    <div class="book-one" @click="viewVideo(item)">
                        <div class="book-img">
                            <img alt="" class="img-100" :src="item.coverUrl" />
                        </div>
                        <div class="book-title">
                            {{ item.title }}
                        </div>
                    </div>
                </div>

                <div class="div-100" v-if="videoList&&videoList.length===0">
                    <dataEmpty title="暂无视频" />
                </div>
            </div>
        </div>
    </div>

    <el-dialog class="ar-dialog" :title="videoName" v-model="isViewVideoShow" top="8vh" width="830px" @close="destroyed">
        <div id="player"></div>
    </el-dialog>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import dataEmpty from "@/components/dataEmpty.vue";
import {searchHumanityVideo} from "@/api/admin/humanity";

export default {
    name: "searchHumanityVideo",
    components: {dataEmpty},
    props:{
        infoWord:{
            type: String,
            default:null
        },
    },
    watch: {
        infoWord(newValue,oldValue){
            this.keyword = newValue;
            this.searchHumanityVideo()
        },
    },
    data() {
        return {
            serviceUrl,
            pageMode:'page',
            isViewVideoShow:false,
            keyword:'',
            museumName:'',
            videoList:[],
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            vid:'',
            videoName:'',
            videoWidth:800,
            videoHeight:500,
        }
    },
    computed: {},
    created() {
        this.searchHumanityVideo();
    },
    mounted(){
        this.keyword = this.infoWord;
        this.searchHumanityVideo();
    },
    methods: {
        backList(){
            this.$emit('change-mode', this.pageMode);
        },
        handleQuery(){
            this.searchHumanityVideo();
        },
        viewVideo(row){
            this.vid = row.videoId;
            this.videoName = row.title;
            this.isViewVideoShow = true;
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#player',
                width: this.videoWidth,
                height: this.videoHeight,
                vid: this.vid,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
            this.isViewVideoShow = false;
        },
        searchHumanityVideo(){
            this.keyword = this.infoWord;
            if (this.keyword===''||this.keyword===null||this.keyword === undefined){
                this.$message.info("请输入搜索关键字");
                return;
            }

            searchHumanityVideo({keyword:this.keyword}).then(res => {
                if (res.data.code === 1) {
                    this.videoList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        }

    }
}

</script>

<style scoped>
.course-container{
    width: 100%;
    height: auto;
}
.base-create-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    overflow-y: auto!important;
    box-sizing: border-box;
    font-family: sans-serif;
}
.head-container{
    width: 100%;
    height: 48px;
    display: flex;
}
.left-head-container{
    width: calc(100% - 80px);
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: 80px;
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #3b62f8;
    line-height: 44px;
    font-weight: bold;
    padding-right: 10px;
    box-sizing: border-box;
}
.info-container{
    width: 100%;
    height: calc(100% - 60px);
    display: flex;
    border-top: 1px solid #f1f1f1;
    flex-wrap: wrap!important;
    padding-top: 10px;
}
.book-item{
    width: 25%;
    height: 200px;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
}
.book-one{
    width: 100%;
    height: 180px;
    box-shadow: var(--el-box-shadow-light);
}
.book-one:hover{
    border: 1.5px solid #3b62f8!important;
    color: #3b62f8!important;
    font-weight: bold;
}
.book-img{
    width: 100%;
    height: 140px;
    cursor: pointer;
}
.book-title{
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    padding: 0 5px 5px 5px;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-family: sans-serif;
}
</style>